<template>
  <div style="width: 100%;">
    <div class="swiper_container">
        <div class="swiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item ,i) in industrialModel" :key="i">
                    <div class="item_container" @click="goModelDetail(item)">
                        <img src="../../../assets/image/48.模型.png">
                        <p>{{ item }}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div> -->
    </div>
    <div class="swiper_container">
        <div class="swiperNext">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item ,i) in industrialModel" :key="i">
                    <div class="item_container" @click="goModelDetail(item)">
                        <img src="../../../assets/image/48.模型.png">
                        <p>{{ item }}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="swiper-button-next2"><i class="el-icon-arrow-right"></i></div>
        <div class="swiper-button-prev2"><i class="el-icon-arrow-left"></i></div> -->
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.css'
// import { industrialModels } from '../../../api/mockData'
export default {
    name:'ModelSwiper',
    data(){
        return{
            industrialModel:industrialModels.slice(0,8),
        }
    },
    methods:{
        goModelDetail() {
            this.$router.push({ path: "/models_detail" });
        }
    },
    mounted(){
        var mySwiper = new Swiper('.swiper',{
            slidesPerView: 5,
            grabCursor: true,
            loop: true,
            spaceBetween: 20,
            navigation: {
                nextEl:'.swiper-button-next',
                prevEl:'.swiper-button-prev',
            }
        })
        var mySwiperNextLine = new Swiper('.swiperNext',{
            slidesPerView: 5,
            grabCursor: true,
            loop: true,
            spaceBetween: 20,
            navigation: {
                nextEl:'.swiper-button-next2',
                prevEl:'.swiper-button-prev2',
            }
        })
    }
}
</script>

<style lang="less" scoped>
p{
    color: #666666;
}
.model_item{
    width: 24%;
    margin-right: 1%;
    margin-top: 1%;
    border-radius: 2%;
    background-color: #b8b8b8;
    .item_container{
        width: 80%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 8% 0;
        img{
            width: 80%;
            margin: 0 auto;
        }
        p{
            text-align: center;
            font-size: 1;
            color: #606266;
        }
    }
}
.swiper_container{
    position: relative;
    width: 100%;
}
.swiper-button-next, .swiper-button-prev{
    height: 90%;
    width: 1.4%;
    top: 20px;
    background: #555555;
    border-radius: 8px;
}
.swiper-button-prev2, .swiper-button-next2{
    height: 18rem;
    width: 1.4%;
    top: 10px;
    background: #555555;
    border-radius: 8px;
    position: absolute;
    cursor: pointer;
}
.swiper-button-next,.swiper-button-next2{
    right: -30px;
}
.swiper-button-prev,.swiper-button-prev2{
    left: -30px;
}
.el-icon-arrow-left{
    position: absolute;
    top: 45%;
    right: -22%;
    color: #fff;
    font-size: 32px;
}
.el-icon-arrow-right{
    position: absolute;
    top: 45%;
    left: -33%;
    color: #fff;
    font-size: 32px;
}
.swiper,.swiperNext {
    width: 100%;
    height: 20rem;
    overflow: hidden;
    --swiper-theme-color: #fff !important;
    --swiper-navigation-color: #fff;/* 单独设置按钮颜色 */
    --swiper-navigation-size: 20px !important;/* 设置按钮大小 */
}
  .swiper-slide {
    text-align: center;
    transition: 300ms;
    transform: scale(1);
    background-color: #eaeaea;
    // width: 24% !important;
    // margin-right: 1% !important;
    height: 300px; /* 调整幻灯片的高度 */
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    color: #333;
    cursor: pointer;
    border-radius: 5%;
  }

//   .swiper-slide-active,.swiper-slide-duplicate-active{
//      transform: scale(1);
//   	}
</style>